<div class="gap-md flex h-full">
  <div class="h-full w-2/3">
    <p>A faire</p>
  </div>
</div>
